module.exports = __webpack_public_path__ + "assets/9c3af146db747b41a5ad5c65215e289a.mp3";